// Import de funcions auxiliars
import {
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/**
* Valida si el valor introduït per una variable ha excedit els llindars definits.
*
* @param valorMinim {Numeric}
* @param valorMaxim {Numeric}
* @param valorIntroduit {Numeric}
* @returns {Boolean}
*/
const shanExceditFiltresDeRang = (valorMinim, valorMaxim, valorIntroduit) => {
    return shaSuperatValorMinim(valorMinim, valorIntroduit) || shaSuperatValorMaxim(valorMaxim, valorIntroduit);
};

/**
* Valida si el valor introduït per una variable ha excedit el llindar inferior.
*
* @param valorMinim {Numeric}
* @param valorIntroduit {Numeric}
* @returns {Boolean}
*/
const shaSuperatValorMinim = (valorMinim, valorIntroduit) => {
    return valorMinim !== null && !isNaN(valorMinim) && valorIntroduit < valorMinim;
};

/**
* Valida si el valor introduït per una variable ha excedit el llindar superior.
*
* @param valorMaxim {Numeric}
* @param valorIntroduit {Numeric}
* @returns {Boolean}
*/
const shaSuperatValorMaxim = (valorMaxim, valorIntroduit) => {
    return valorMaxim !== null && !isNaN(valorMaxim) && valorIntroduit > valorMaxim;
};

/**
* Recorre tota l'estructura del formulari i valida els filtres de rang de cada una
* de les variables. Si es detecta un error, s'afegeix a l'array d'errors.
*
* @param nouVariables {Object}
*/
export const checkFiltresRang = (nouVariables) => {
    Object.keys(nouVariables).forEach((nomGrup) => {
        const grup = nouVariables[nomGrup];

        grup.forEach((variable) => {
            const { nomVariable, valorMinim, valorMaxim } = variable;
            const valorIntroduit = obteValorVariable(variable);

            if (valorIntroduit && shanExceditFiltresDeRang(valorMinim, valorMaxim, valorIntroduit)) {
                const MSG_VALOR_FORA_DE_RANG = 'El valor de la variable ' + nomVariable + ' ha d\'estar comprès entre ' + valorMinim + ' i ' + valorMaxim;
                afegeixErrorAVariable(variable, MSG_VALOR_FORA_DE_RANG);
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/filtresRang.js